import { render, staticRenderFns } from "./GarantSect.vue?vue&type=template&id=22cef6d2&"
import script from "./GarantSect.vue?vue&type=script&lang=js&"
export * from "./GarantSect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('22cef6d2', component.options)
    } else {
      api.reload('22cef6d2', component.options)
    }
    module.hot.accept("./GarantSect.vue?vue&type=template&id=22cef6d2&", function () {
      api.rerender('22cef6d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/page-part/GarantSect.vue"
export default component.exports